;(function () {

"use strict";

var SocialMediaView = Backbone.View.extend({
  initialize: function (opts) {
    this.opts  = opts || {};
    // console.log('init social media view');
    this.href = opts.href || window.location.href;
    this.description = opts.description || $('meta[property="og:description"]').attr('content');
    this.media = opts.media || $('meta[property="og:image"]').attr('content');
  },
  facebook: function () {
    window.open(encodeURI('http://www.facebook.com/sharer/sharer.php?u='+this.href), '_blank', "status = 1, height = 420, width = 550");
  },
  twitter: function () {
    // console.log('twitter');
    window.open(encodeURI("http://twitter.com/share?&url="+this.href+"&hashtags=roseandrex,playisokay"), '_blank', "status = 1, height = 420, width = 550");
  },
  pinterest: function () {
    // console.log('pinterest');
    window.open(encodeURI("http://pinterest.com/pin/create/button/?url="+this.href+"&media="+this.media+"&description="+this.description), '_blank', "status = 1, height = 420, width = 550");
  },
  email: function () {
    location.href = "mailto:?&body="+window.location.href;
  },
  share: function (e) {
    var type = $(e.currentTarget).attr('class');
    if (this[type]) {
      this[type]();
    }
    return false;
  },
  events: {
    'click li:last-child > ul > li': 'share'
  }
});

module.exports = SocialMediaView;

}());